import React, { ReactNode } from 'react';
import InfoIcon from '@material-ui/icons/Info';
import { NoDataFoundStyled } from './no-data-found.styled';

type TNodataFound = {
    label?: string;
    children?: ReactNode;
};

const NoDataFound: React.FC<TNodataFound> = ({ label, children = '' }) => {
    return (
        <NoDataFoundStyled>
            <InfoIcon fontSize="small" />{' '}
            <span>{label || 'There is no data found.'}</span>
            {children}
        </NoDataFoundStyled>
    );
};

export default NoDataFound;
